// @flow

import createPurchaseOrderLineQuantitiesTableColumn from './components/table/PurchaseOrderLineQuantitiesTableColumn';
import createPurchaseOrderLineQuantityAndSoldQuantityTableColumn from './components/table/PurchaseOrderLineQuantityAndSoldQuantityTableColumn';

import PurchaseOrderLineDiscountCellRenderer from './components/table/PurchaseOrderLineDiscountCellRenderer';
import PurchaseOrderLinesTableRowExtension from './components/table/PurchaseOrderLinesTableRowExtension';

import purchaseOrderLinesTableConfiguration from './components/configuration/purchaseOrderLinesTableConfiguration';
import addPurchaseOrderLineModalConfiguration from './components/configuration/addPurchaseOrderLineModalConfiguration';

import TradeTimelineItem from '../../trix-web-plugin-wms-trade/web/components/timeline/TradeTimelineItem';


export const components = {
    'tableColumn:purchaseOrderLineQuantities': createPurchaseOrderLineQuantitiesTableColumn,
    'tableColumn:purchaseOrderLineQuantityAndSoldQuantity': createPurchaseOrderLineQuantityAndSoldQuantityTableColumn,

    // 'tableCellRenderer:purchaseOrderLineDiscount': PurchaseOrderLineDiscountCellRenderer,
    'tableRowExtension:trix-web-plugin-wms-purchaseorder.managePurchaseOrderPage.container.purchaseOrderLinesTable': PurchaseOrderLinesTableRowExtension,
    'configuration:trix-web-plugin-wms-purchaseorder.managePurchaseOrderPage.container.purchaseOrderLinesTable.table': purchaseOrderLinesTableConfiguration,
    'configuration:trix-web-plugin-wms-purchaseorder.managePurchaseOrderPage.container.purchaseOrderLinesTable.action.onAddItem.editor.modal': addPurchaseOrderLineModalConfiguration,

    'timelineItem:trix-web-plugin-wms-purchaseorder.managePurchaseOrderPage.container.trade': TradeTimelineItem,
}
